<section class="hearing-cycle" data-testid="hearing-cycle-workspace">
  <div
    *ngIf="scheduledProceedingId() === null"
    class="hearing-cycle__state hearing-cycle__state--error"
    data-testid="phase-error"
  >
    {{ hearingText.noSelection() }}
  </div>

  <ng-container *ngIf="scheduledProceedingId() !== null">
    <ez-workspace-frame>
      <phms-hearing-page-header
        frameSummary
        [phase]="routePhase()"
        [status]="hearingStatus()"
        [statusCode]="hearingStatusCode()"
        [currentStepLabel]="workflowCurrentStepLabel()"
        [record]="record()"
        [scheduledProceedingId]="scheduledProceedingId()"
        [ledger]="displayWorkflowLedger()"
        [ledgerState]="workflowLedgerState()"
        [isLoading]="isLoadingContext()"
      ></phms-hearing-page-header>

      <header
        frameActions
        class="phase-heading"
        aria-label="Hearing task summary and actions"
        data-testid="phase-summary-bar"
      >
        <h2
          class="phase-title"
          tabindex="-1"
          data-testid="hearing-section-title"
        >
          {{ navigation.sectionLabel() }}
        </h2>
        <div class="phase-actions">
          <ng-container *ngFor="let entry of phaseBar.actions()">
            <ng-container [ngTemplateOutlet]="entry.template"></ng-container>
          </ng-container>
        </div>
      </header>
      <div frameMain class="hearing-cycle__primary">
        <div class="hearing-cycle__workarea">
          <div
            *ngIf="isLoadingContext()"
            class="hearing-cycle__state"
            data-testid="context-loading"
          >
            Loading hearing context…
          </div>
          <div
            *ngIf="contextError() as error"
            class="hearing-cycle__state hearing-cycle__state--error"
            data-testid="context-error"
          >
            {{ error }}
          </div>

          <main class="hearing-cycle__content" [attr.aria-label]="pageTitle()">
            <phms-hearing-workflow-task-panel
              [scheduledProceedingId]="scheduledProceedingId()"
            ></phms-hearing-workflow-task-panel>
            <router-outlet></router-outlet>
          </main>
        </div>
      </div>

      <aside
        frameContext
        class="hearing-cycle__snapshot"
        aria-label="Case snapshot"
        data-testid="case-snapshot-rail"
      >
        <phms-case-context-snapshot-rail
          *ngIf="incarceratedPersonId() as personId; else snapshotUnavailable"
          [incarceratedPersonId]="personId"
          [showHearingDetailAction]="false"
          [workflowCurrentStepLabel]="workflowCurrentStepLabel()"
          data-testid="rail-case-snapshot"
        ></phms-case-context-snapshot-rail>
        <ng-template #snapshotUnavailable>
          <section class="snapshot-unavailable">
            <h2>Case Snapshot</h2>
            <p>
              {{
                isLoadingContext()
                  ? "Loading case context…"
                  : "Case context is unavailable for this proceeding."
              }}
            </p>
          </section>
        </ng-template>
      </aside>
    </ez-workspace-frame>
  </ng-container>
</section>
